(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["classic-gallery-lightbox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section');
    if (!(section instanceof HTMLElement)) return;

    const dialog = section.querySelector('[data-gallery-dialog]');
    const dialogImage = section.querySelector('[data-gallery-image]');
    const spinner = section.querySelector('[data-gallery-spinner]');
    const captionEl = section.querySelector('[data-gallery-caption]');
    const counterEl = section.querySelector('[data-gallery-counter]');
    const filmstrip = section.querySelector('[data-gallery-filmstrip]');
    if (!(dialog instanceof HTMLDialogElement) || !(dialogImage instanceof HTMLImageElement)) return;

    const openers = Array.from(section.querySelectorAll('[data-gallery-open]'));
    if (openers.length === 0) return;

    let current = -1;
    let lastFocus = null;

    // 构建胶片缩略图条
    const thumbs = openers.map((btn) => {
      const t = btn.getAttribute('data-gallery-thumb') || btn.getAttribute('data-gallery-src');
      const alt = btn.getAttribute('data-gallery-alt') || '';
      const img = document.createElement('img');
      img.src = t;
      img.alt = alt;
      img.className = 'classic-gallery-lightbox__thumb';
      img.loading = 'lazy';
      img.addEventListener('click', () => show(openers.indexOf(btn)));
      filmstrip.appendChild(img);
      return img;
    });

    const render = (i) => {
      const btn = openers[i];
      const src = btn.getAttribute('data-gallery-src');
      if (!src) return;

      const alt = btn.getAttribute('data-gallery-alt') || '';
      const cap = btn.getAttribute('data-gallery-caption') || '';

      // 交叉淡入：先淡出再换图
      dialogImage.classList.remove('is-loaded');
      if (spinner) spinner.classList.add('is-active');
      dialogImage.src = src;
      dialogImage.alt = alt;

      if (captionEl) {
        captionEl.textContent = cap;
        captionEl.classList.toggle('is-hidden', !cap);
      }
      if (counterEl) counterEl.textContent = (i + 1) + ' / ' + openers.length;
      thumbs.forEach((el, idx) => el.classList.toggle('is-active', idx === i));
      // 滚动胶片条让当前缩略图可见
      if (thumbs[i]) thumbs[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    };

    const show = (i) => {
      current = (i + openers.length) % openers.length;
      render(current);
      if (!dialog.open) dialog.showModal();
    };

    dialogImage.addEventListener('load', () => {
      dialogImage.classList.add('is-loaded');
      if (spinner) spinner.classList.remove('is-active');
    });

    // 打开
    section.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-gallery-open]') : null;
      if (!(target instanceof HTMLElement)) return;
      lastFocus = document.activeElement;
      show(openers.indexOf(target));
    });

    // 关闭：按钮 / 背景
    section.addEventListener('click', (event) => {
      if (event.target.closest('[data-gallery-close]')) dialog.close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.classList.contains('classic-gallery-lightbox__dialog-inner')) dialog.close();
    });

    // 上一张 / 下一张
    const prev = () => show(current - 1);
    const next = () => show(current + 1);
    section.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-gallery-prev]');
      if (btn) { event.stopPropagation(); prev(); }
    });
    section.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-gallery-next]');
      if (btn) { event.stopPropagation(); next(); }
    });

    // 键盘
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); prev(); }
    });

    // 关闭后焦点归位
    dialog.addEventListener('close', () => {
      if (lastFocus instanceof HTMLElement) lastFocus.focus();
    });

    // 触屏滑动切换
    let touchX = null;
    dialogImage.addEventListener('touchstart', (e) => { touchX = e.changedTouches[0].clientX; }, { passive: true });
    dialogImage.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) (dx < 0 ? next() : prev());
      touchX = null;
    }, { passive: true });

    // 入场动画（错峰淡入上移）
    const grid = section.querySelector('[data-gallery-grid]');
    if (grid && 'IntersectionObserver' in window) {
      grid.classList.add('is-reveal');
      const items = grid.querySelectorAll('.classic-gallery-lightbox__item');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const i = parseInt(el.style.getPropertyValue('--i') || '0', 10);
            el.style.transitionDelay = Math.min(i, 8) * 55 + 'ms';
            el.classList.add('is-visible');
            io.unobserve(el);
          }
        });
      }, { threshold: 0.12 });
      items.forEach((el) => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-editorial-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var READY = 'contactEditorialReady';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function revealCards(section) {
      var cards = section.querySelectorAll('.contact-editorial__card');

      if (!('IntersectionObserver' in window) || reduceMotion.matches) {
        cards.forEach(function (card) {
          card.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );

      cards.forEach(function (card, index) {
        card.style.setProperty('--reveal-delay', index * 90 + 'ms');
        observer.observe(card);
      });
    }

    function pointerGlow(section) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (!section.classList.contains('contact-editorial--glow')) return;

      var frame = null;
      var activeCard = null;
      var posX = 0;
      var posY = 0;

      function paint() {
        frame = null;
        if (!activeCard) return;
        activeCard.style.setProperty('--glow-x', posX + '%');
        activeCard.style.setProperty('--glow-y', posY + '%');
      }

      section.addEventListener(
        'pointermove',
        function (event) {
          if (!(event.target instanceof Element)) return;
          var card = event.target.closest('.contact-editorial__card');
          if (!card) return;

          var rect = card.getBoundingClientRect();
          activeCard = card;
          posX = ((event.clientX - rect.left) / rect.width) * 100;
          posY = ((event.clientY - rect.top) / rect.height) * 100;

          if (frame === null) frame = window.requestAnimationFrame(paint);
        },
        { passive: true }
      );

      section.addEventListener(
        'pointerleave',
        function () {
          activeCard = null;
        },
        { passive: true }
      );
    }

    function setup(section) {
      if (section[READY]) return;
      section[READY] = true;
      revealCards(section);
      pointerGlow(section);
    }

    function initAll() {
      document.querySelectorAll('.contact-editorial').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var node = event.target;
      if (node && node.classList && node.classList.contains('contact-editorial')) {
        setup(node);
      } else {
        initAll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
